import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../../core/Loading';
import { usePermission } from '../../core/PermissionContext';
import { isAuthenticated } from '../../utils/auth';

const ProtectedRoute = ({ children, requireAuth = true }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loadingPermissions } = usePermission();

    useEffect(() => {
        if (requireAuth && !isAuthenticated()) {
            const currentPath = location.pathname + location.search;
            if (currentPath !== '/login' && !currentPath.startsWith('/login?')) {
                sessionStorage.setItem('redirectAfterLogin', currentPath);
            }
            navigate('/login');
        }
    }, [navigate, location, requireAuth]);

    if (loadingPermissions) {
        return <Loading />;
    }

    if (requireAuth && !isAuthenticated()) {
        return null;
    }

    return children;
};

export default ProtectedRoute;
